export const LOGIN_REDIRECT_BOARD = 'board';
export const LOGIN_REDIRECT_BLOCKS = 'blocks';

export function normalizeLoginRedirect(value) {
  return value === LOGIN_REDIRECT_BLOCKS ? LOGIN_REDIRECT_BLOCKS : LOGIN_REDIRECT_BOARD;
}

export function resolveLoginRedirectPath(currentUser) {
  const rawValue = currentUser?.user_metadata?.login_redirect
    ?? currentUser?.profile?.profile_data?.login_redirect;
  const redirect = normalizeLoginRedirect(rawValue);

  return redirect === LOGIN_REDIRECT_BLOCKS ? '/blocks' : '/';
}

export function resolveAuthRedirect(routeQuery = {}, currentUser) {
  const explicitRedirect = routeQuery?.redirectFrom || routeQuery?.redirect;

  if (typeof explicitRedirect === 'string' && explicitRedirect.trim()) {
    return explicitRedirect;
  }

  return resolveLoginRedirectPath(currentUser);
}